<div class="active-carrier-app sec-gap">
  <div class="contact-dash white-bg">
    <div class="graph-header">
      <div class="left-part">
        <div class="graph-title">
          <h3 class="title">Logs</h3>
        </div>
      </div>
      <div class="right-part" *ngIf="tabActive == '#activity-log'">
          <div class="action-block">
            <span class="go-to-icon addlink" (click)="viewActivityReport()"><img class="ver-middle" title="Detail view" src="assets/images/go-to-detail.svg" /></span>
            
            <div class="more-info">
              <svg class="ic-more" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <rect id="Rectangle_657" data-name="Rectangle 657" width="20" height="20" fill="none" />
                <path id="more_vert_FILL0_wght400_GRAD0_opsz20" d="M10,16a1.5,1.5,0,1,1,1.062-.438A1.444,1.444,0,0,1,10,16Zm0-4.5A1.5,1.5,0,0,1,8.938,8.938a1.5,1.5,0,0,1,2.124,2.124A1.444,1.444,0,0,1,10,11.5ZM10,7A1.5,1.5,0,0,1,8.5,5.5a1.5,1.5,0,0,1,2.562-1.062,1.506,1.506,0,0,1,0,2.124A1.444,1.444,0,0,1,10,7Z" fill="#757575" />
              </svg>
            </div>
          </div>
        </div>
          <div class="right-part" *ngIf="tabActive == '#emailNotification'">
          <div class="action-block">
            <span class="go-to-icon addlink" (click)="viewEmailNotificationReport()"><img class="ver-middle" title="Detail view" src="assets/images/go-to-detail.svg" /></span>
            
            <div class="more-info">
              <svg class="ic-more" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <rect id="Rectangle_657" data-name="Rectangle 657" width="20" height="20" fill="none" />
                <path id="more_vert_FILL0_wght400_GRAD0_opsz20" d="M10,16a1.5,1.5,0,1,1,1.062-.438A1.444,1.444,0,0,1,10,16Zm0-4.5A1.5,1.5,0,0,1,8.938,8.938a1.5,1.5,0,0,1,2.124,2.124A1.444,1.444,0,0,1,10,11.5ZM10,7A1.5,1.5,0,0,1,8.5,5.5a1.5,1.5,0,0,1,2.562-1.062,1.506,1.506,0,0,1,0,2.124A1.444,1.444,0,0,1,10,7Z" fill="#757575" />
              </svg>
            </div>
          </div>
        </div>

    </div>
    <div class="active-carrier-app-info dash-nipr-block">

      <div class="tab common-tab p-0 widget-tab" role="tabpanel">
        <ul class="nav nav-tabs sticky-top" role="tablist" (click)="getSelectedTab($event)">
          <li class="nav-item">
            <a class="nav-link active" (contextmenu)="$event.preventDefault()" href="#emailNotification" aria-controls="email" role="tab"
               data-toggle="tab">Email Notifications</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (contextmenu)="$event.preventDefault()" href="#activity-log" aria-controls="audit" role="tab" data-toggle="tab">Activity Logs</a>
          </li>
        </ul>
        <div class="tab-content">
          <div *ngIf="tabActive == '#emailNotification'"
               role="tabpanel" class="tab-pane active in" id="emailNotification" style="height:257px; overflow-y:auto;"
               (scroll)="onScroll($event)">
            <div class="audit-log-table">
              <table *ngIf="EmailNotificationList?.length > 0">
                <thead class="sticky-table-header">
                  <tr class="audit-log-header">
                    <th>Subject</th>
                    <th>Date Sent</th>
                    <th>Email Address</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="audit-log-list" *ngFor="let emailList of EmailNotificationList" [class.row-highlight]="emailList.emailNotificationLogId == selectedRecordId" (click)="selectedRecordId = emailList.emailNotificationLogId">
                    <td><span appEllipsifyMe class="max-width-tooltip-400"><a href="javascript:void(0)" (click)="openEmailNotificationModal(emailList.emailNotificationLogId)">{{emailList.emailType}}</a></span></td>
                    <td class="max-width-tooltip-150">{{emailList?.sentOn | date :'MM/dd/yyyy hh:mm a'}}</td>
                    <td><span appEllipsifyMe class="max-width-tooltip-230">{{emailList.email}}</span></td>
                  </tr>
                </tbody>
              </table>

            </div>
            <!-- <app-no-data-found *ngIf="activeList && EmailNotificationList.length <= 0 " [isGraphDashboard]="'false_true_ _ _ Email notification history will be displayed here when available.'"></app-no-data-found> -->
              <div class="no-data-found p-0" *ngIf="activeList && EmailNotificationList?.length <= 0">

                  <div class="no-data-found">
                  <img [ngClass]="{'dashboard-img': true}" src="../../../../assets/images/no-data.svg" >
                  <h5>No email notification records found</h5>
                  <div class="margin-block"><a href="" class="link-modal"></a> 
                      Email notification history will be displayed here when available.</div>
                  </div>
              </div>

            <div class="common-loader mt-5 pt-4" [hidden]="!showLoader" >
              <div class="loader-icon mt-4">
                <img src="assets/images/common-loader.gif" alt="">
              </div>
            </div>
          </div>
          <div *ngIf="tabActive == '#activity-log'" role="tabpanel" class="tab-pane active in" id="activity-log">
            <app-activity-log [userId]="userId"></app-activity-log>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
